<div class="flex flex-col text-left !p-4 bg-deep-blue-850 rounded-lg gap-8 w-full h-full">
    <div class="text-[56px] text-bold-green" [class]="icon()"></div>
    <div class="flex flex-col pb-4">
        @if (kpi()) {
            <h2 class="text-[20px] leading-6 font-bold">{{ kpi() | number: '1.0-0' }}{{ unit() }}</h2>
        } @else {
            <h2 class="text-[20px] leading-6 font-bold text-secondary">
                {{ notDefinedValue().toString() | translate }}
            </h2>
        }
        <p class="text-secondary">
            {{ property() | translate }}
        </p>
    </div>
</div>
